import { Divider } from '~/components/ui/Divider';
import { CraftList } from '../../components/CraftList';
import { CraftMenu } from '../../components/CraftMenu';
import { Head } from '../../components/Head';
import { StyledContainer, StyledLayout } from './Workbench.styled';

const Workbench = () => {
	return (
		<StyledContainer>
			<Head />
			<StyledLayout>
				<CraftList />
				<Divider $direction="V" style={{ opacity: 0.1 }} />
				<CraftMenu />
			</StyledLayout>
		</StyledContainer>
	);
};

export { Workbench };
